import { FINISH_LOADING, START_LOADING } from '../actionTypes'

export const startLoading = (componentName: string) => ({ type: START_LOADING, payload: componentName })
export const finishLoading = (componentName: string) => ({ type: FINISH_LOADING, payload: componentName })
